import { forwardRef, type SelectHTMLAttributes } from "react";
import styles from "./input.module.scss";

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  inputSize?: "sm" | "md" | "lg";
  error?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ inputSize = "md", error, className, children, ...props }, ref) => {
    const cls = [
      styles.input,
      styles[inputSize],
      error ? styles.error : "",
      className ?? "",
    ].filter(Boolean).join(" ");

    return (
      <select ref={ref} className={cls} {...props}>
        {children}
      </select>
    );
  },
);

Select.displayName = "Select";
